export const FEATURE_FLAGS: Record<string, string> = {
  // TODO: Remove with AE-675
  ENTERPRISE_SHOW_SSO_IN_DASHBOARD: 'enterprise-show-sso-in-dashboard',
  ENTERPRISE_MANAGE_USERS_DASHBOARD: 'enterprise-manage-users-dashboard',
};

export const getFeatureFlags = () => {
  return Object.values(FEATURE_FLAGS);
};
